export enum DonationReminderTrigger {
  LOW = 'low',
  MODERATE = 'moderate',
  HIGH = 'high',
  URGENT = 'urgent',
}
